<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="preinscripcion" titulo="Preinscripción / Promoción"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span style="overflow-y:auto; overflow-x:hidden; display:block; height: 79vh;">

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando "
                    style="overflow:auto;">
                    <thead>
                        <tr>
                            <th style="vertical-align: middle;"><abbr>Folio</abbr></th>
                            <th style="vertical-align: middle;">Inscrito</th>
                            <th style="vertical-align: middle;">Nombre/ CURP</th>
                            <th style="vertical-align: middle;">Período Escolar</th>
                            <th style="vertical-align: middle;">Carrera</th>
                            <th style="vertical-align: middle;">Grupo</th>
                            <th style="vertical-align: middle; text-align: center;">Documentación completa</th>
                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <th style="vertical-align: middle;">{{ item.folio }}</th>
                            <td style="vertical-align: middle; text-align: center;">
                                <span *ngIf="item.esta_inscrito==1">
                                    <i class="fa fa-circle has-text-success" title="Inscrito"></i></span>
                                <span *ngIf="item.esta_inscrito==0">
                                    <i class="fa fa-circle has-text-danger" title="No Inscrito"></i></span>
                            </td>

                            <th style="vertical-align: middle; font-weight: normal;"> <b>{{ item.apellido_paterno }} {{
                                item.apellido_materno }} {{ item.nombre }}</b> <br> {{ item.curp }}</th>
                            <td style="vertical-align: middle;">
                                <span *ngIf=" item.grupos">{{ item.grupos.periodos_escolares.nombre }} / {{
                                    item.grupos.periodos_escolares.modalidades.nombre }} / {{
                                    item.grupos.periodos_escolares.tipos_periodos.nombre }}</span>
                            </td>
                            <td style="vertical-align: middle;">
                                <span *ngIf="item.grupos">{{ item.grupos.carreras_planes.carreras.nombre }}</span>
                            </td>
                            <td style="vertical-align: middle;">
                                <h4 *ngIf="item.grupos">{{ item.grupos.clave }} {{ item.grupos.nivel }} {{
                                    item.grupos.identificador }} <small></small> </h4>
                            </td>
                            <td style="vertical-align: middle; text-align: center;">
                                <span *ngIf="item.requisitos_faltantes==0">
                                <i class="fa fa-check has-text-success fa-2x" title="Entregado"></i>
                                </span>
                                <span *ngIf="item.requisitos_faltantes > 0">
                                <i class="fa fa-warning fa-2x" style="color: orangered;" title="No entregado"></i>
                                </span>
                            </td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl"
                                    class="level-left"></app-tabla-acciones>
                                <!-- <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left" *ngIf="item.esta_inscrito==0"></app-tabla-acciones> -->
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="8" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
            
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>